module.exports = __webpack_public_path__ + "img/ledger.deac52f1.svg";